module.exports = __webpack_public_path__ + "img/2.ef2d006d.jpeg";